var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeparture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.64409C17.8571 10.7021 16.6046 13.2514 15.2381 16.0533C13.4346 19.751 11.2771 23.5833 9.99996 24.2858C8.68987 23.3249 6.58089 19.7843 4.76187 16.0533C3.46393 13.3911 2.14282 10.632 2.14282 8.64409C2.14282 3.87009 5.66058 0 9.99996 0C14.3393 0 17.8571 3.87009 17.8571 8.64409Z",
    fill: "#3967BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.64409C17.8571 10.7021 16.6046 13.2514 15.2381 16.0533C13.4346 19.751 11.2771 23.5833 9.99996 24.2858C8.68987 23.3249 6.58089 19.7843 4.76187 16.0533C3.46393 13.3911 2.14282 10.632 2.14282 8.64409C2.14282 3.87009 5.66058 0 9.99996 0C14.3393 0 17.8571 3.87009 17.8571 8.64409Z",
    fill: "#3967BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 10C19.2857 15.1284 15.1284 19.2858 10 19.2858C4.87164 19.2858 0.714287 15.1284 0.714287 10C0.714287 4.87165 4.87164 0.714287 10 0.714287C15.1284 0.714287 19.2857 4.87165 19.2857 10Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.42857
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 10C19.2857 15.1284 15.1284 19.2858 10 19.2858C4.87164 19.2858 0.714287 15.1284 0.714287 10C0.714287 4.87165 4.87164 0.714287 10 0.714287C15.1284 0.714287 19.2857 4.87165 19.2857 10Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.42857
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 7.83865C10.4603 7.83865 10.8334 7.46924 10.8334 7.01356C10.8334 6.55788 10.4603 6.18848 10.0001 6.18848C9.53984 6.18848 9.16675 6.55788 9.16675 7.01356C9.16675 7.46924 9.53984 7.83865 10.0001 7.83865Z",
    stroke: "#3967BF",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.90088C13.75 11.9515 12.0711 13.6138 10 13.6138C7.92893 13.6138 6.25 11.9515 6.25 9.90088",
    stroke: "#3967BF",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.25098V13.614",
    stroke: "#3967BF",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.90088H6.25",
    stroke: "#3967BF",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.90088H12.5",
    stroke: "#3967BF",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9.90102,
    fill: "white",
    transform: "translate(5 4.95068)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparture);
export default __webpack_public_path__ + "static/media/departure.0fb7f135eba3ccecc8ab56e687c18c8b.svg";
export { ForwardRef as ReactComponent };